<div class="accordion">
  <div *ngIf="accordionController">
    <div class="row">
      <div class="col-sm-12 col-md-12">
        <div *ngIf = "isFaq" class="format pull-left">
          <h2>{{accordionHeading}}</h2>
        </div>
        <div [ngClass]="isFaq ? 'format pull-right format-third' : 'format pull-right format-second'">
          <a href="javascript:void(0);" [ngClass]="{'disabled': expand}" [attr.aria-disabled]="expand?'true':'false'"
            (click)="expandAll('open')"> Expand all </a> |
          <a href="javascript:void(0);" (click)="collapseAll('close')" [attr.aria-disabled]="!expand?'true':'false'"
            [ngClass]="{'disabled': !expand}"> Collapse all </a>
        </div>
      </div>
    </div>
  </div>
  <ng-content> </ng-content>
</div>